/* Pretty in Pink: productpagina extra's, geladen vanuit layout/theme.liquid (alleen product templates).
   1) Wishlist hartje bij de titel (Loavies-opzet): eigen dun hartje, gekoppeld aan Growave.
      Het getal eronder = echte saves + weging verkoop (90 dagen) + weging tijd online, zie CFG hieronder.
      Bij save/unsave telt het getal direct mee op dit device. Data komt uit window.pipProduct (theme.liquid).
   2) Desktop: zelfde hartje als vierkante knop naast de add-to-cart knop.
   3) Label (Sale/Nieuw/Bestseller): mobiel als pill linksonder op de foto, desktop als tekst boven de titel.
   4) Zoom: mobiel een klein icoontje rechtsonder + eigen fullscreen viewer met alle foto's en dubbeltik zoom.
      Desktop houdt de Dawn lightbox, alleen zonder vergrootglas-knop. */
(function () {
  'use strict';

  /* Fase 2, groep 6: de waarden komen uit de thema-editor (Thema-instellingen > PIP productpagina),
     doorgegeven via snippets/pip-thema-stijl.liquid als window.pipProductCfg. Ontbreekt die, dan gelden de oude waarden hieronder. */
  var UC = window.pipProductCfg || {};
  function num(v, d) { return (typeof v === 'number' && !isNaN(v)) ? v : d; }
  var CFG = {
    SALES_WEIGHT: num(UC.salesPct, 25) / 100, /* aandeel van de verkochte stuks (laatste 90 dagen) in het getal */
    DAYS_WEIGHT: 1,     /* punten per dag online */
    DAYS_CAP: num(UC.daysMax, 60),       /* maximale punten uit tijd online */
    ZOOM_SCALE: num(UC.zoom, 1.8),    /* hoeveel dubbeltikken inzoomt */
    SHOW_TRUSTPILOT: UC.showTp !== false, /* true = Trustpilot sterren boven de productnaam tonen, false = verbergen */
    SIZE_LEFT: num(UC.sizeLeft, 3),   /* 'nog x' onder een maat vanaf deze voorraad; 0 = nooit */
    ATC_SHORT: (typeof UC.atcShort === 'string') ? UC.atcShort : 'Toevoegen', /* korte knoptekst desktop; leeg = gewone tekst */
    ZOOM_TIP: UC.zoomTip || 'Klik om te zoomen'
  };

  var data = window.pipProduct || { saves: 0, sales: 0, days: 0, label: '' };
  var baseCount = Math.round(
    (data.saves || 0) +
    CFG.SALES_WEIGHT * (data.sales || 0) +
    Math.min((data.days || 0) * CFG.DAYS_WEIGHT, CFG.DAYS_CAP)
  );

  var state = { known: false, saved: false, initialSaved: false, ph: null, hearts: [], countEl: null };

  /* Houd de Growave wishlist-calls in de gaten: zo weten we zeker wanneer dit product
     wordt toegevoegd of verwijderd (het icoon in de Growave widget loopt soms achter). */
  (function patchNet() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var pid = String((meta && meta.product && meta.product.id) || '');
    if (!pid) return;
    /* exacte product-id match: geen substring-treffers op andere producten */
    var pidRe = new RegExp('"productId"\\s*:\\s*"?' + pid + '(\\D|$)');
    function bodyHasPid(b) {
      if (!b) return false;
      try {
        var j = JSON.parse(String(b));
        var p = j.productId || (j.item && j.item.productId) || (j.data && j.data.productId);
        if (p != null) return String(p) === pid;
      } catch (e) {}
      return pidRe.test(String(b));
    }
    function handle(url, body) {
      try {
        url = String(url || '');
        if (url.indexOf('wishlist-storefront') === -1) return;
        if (url.indexOf('deleteItem') > -1) {
          var m = url.match(/[?&]productId=(\d+)/);
          if ((m && m[1] === pid) || bodyHasPid(body)) setSaved(false);
        } else if (url.indexOf('addItem') > -1 && bodyHasPid(body)) {
          setSaved(true);
        }
      } catch (e) {}
    }
    /* de status-call bij het laden van de pagina is de betrouwbare beginstand */
    function applyStatuses(j) {
      try {
        (j && j.results ? j.results : []).forEach(function (it) {
          if (String(it.productId) === pid) {
            state.known = true;
            state.initialSaved = !!it.productInWishlist;
            state.saved = !!it.productInWishlist;
            render();
          }
        });
      } catch (e) {}
    }
    var of = window.fetch;
    if (of) {
      window.fetch = function (input, init) {
        var url = String((typeof input === 'string' ? input : (input && input.url)) || '');
        handle(url, init && init.body);
        var res = of.apply(this, arguments);
        if (url.indexOf('getWishlistProductStatuses') > -1 && res && res.then) {
          res.then(function (r) { return r.clone().json(); }).then(applyStatuses).catch(function () {});
        }
        return res;
      };
    }
    var oo = XMLHttpRequest.prototype.open;
    var os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__pipUrl = u; return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (b) {
      handle(this.__pipUrl, b);
      if (String(this.__pipUrl || '').indexOf('getWishlistProductStatuses') > -1) {
        this.addEventListener('load', function () {
          try { applyStatuses(JSON.parse(this.responseText)); } catch (e) {}
        });
      }
      return os.apply(this, arguments);
    };
  })();

  function setSaved(s) {
    if (!state.known) { state.known = true; state.initialSaved = !s; }
    state.saved = s;
    render();
  }

  var HEART_PATH = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
  var COPY_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="1.5"/><path d="M15 9V6.5A2.5 2.5 0 0 0 12.5 4H6a2 2 0 0 0-2 2v6.5A2.5 2.5 0 0 0 6.5 15H9"/></svg>';
  var X_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" style="width:16px;height:16px;stroke:#121212;stroke-width:1.8;fill:none;"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  function heartSVG() {
    return '<svg class="pip-heart-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="' + HEART_PATH + '"/></svg>';
  }

  /* ---------- wishlist hartjes ---------- */

  function makeHeartBtn(extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pip-heart-btn' + (extraClass ? ' ' + extraClass : '');
    b.setAttribute('aria-label', 'Bewaar in wishlist');
    b.setAttribute('aria-pressed', state.saved ? 'true' : 'false');
    b.innerHTML = heartSVG();
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var root = state.ph && state.ph.shadowRoot;
      var gw = root && (root.querySelector('button.gw-toggle-wishlist-product-card-button') || root.querySelector('button'));
      /* zonder Growave knop niets doen: anders kleurt het hartje zonder dat er echt iets wordt opgeslagen */
      if (!gw) return;
      /* doel eerst vastleggen: de netwerk-interceptie kan de state al bijwerken zodra de Growave klik zijn call doet */
      var target = !state.saved;
      gw.click();
      setSaved(target);
    });
    state.hearts.push(b);
    return b;
  }

  /* Noodgreep als de status-call uitblijft: beginstand aflezen van het Growave icoon
     (roze fill = al in de wishlist). Bewust pas na een paar seconden, want het icoon
     kan verouderd zijn en de status-call is leidend. */
  function initialProbe() {
    if (state.known) return true;
    var root = state.ph && state.ph.shadowRoot;
    var p = root && root.querySelector('svg.gw-wl-icon path');
    if (!p) return false;
    var fill = getComputedStyle(p).fill;
    if (!fill) return false;
    state.known = true;
    state.initialSaved = fill !== 'rgb(18, 18, 18)';
    state.saved = state.initialSaved;
    render();
    return true;
  }

  function currentCount() {
    var c = baseCount;
    if (state.known) {
      if (state.saved && !state.initialSaved) c += 1;
      if (!state.saved && state.initialSaved) c -= 1;
    }
    return Math.max(c, 0);
  }

  function render() {
    state.hearts.forEach(function (b) {
      b.classList.toggle('is-saved', !!state.saved);
      /* status doorgeven aan schermlezers (fase 2, B1-08) */
      b.setAttribute('aria-pressed', state.saved ? 'true' : 'false');
    });
    if (state.countEl) state.countEl.textContent = currentCount();
  }

  function injectTitle() {
    var title = document.querySelector('.product__info-container .product__title');
    if (!title) return false;
    if (title.querySelector('.pip-pheart')) return true;
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var pid = meta && meta.product && meta.product.id;
    var vEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!pid || !vEl || !vEl.value) return false;

    var wrap = document.createElement('div');
    wrap.className = 'pip-pheart';

    var ph = document.createElement('div');
    ph.className = 'gw-add-to-wishlist-product-card-placeholder';
    ph.setAttribute('data-gw-product-id', pid);
    ph.setAttribute('data-gw-variant-id', vEl.value);
    ph.setAttribute('data-pip-heart-done', '1');
    ph.style.display = 'none';
    state.ph = ph;

    wrap.appendChild(ph);
    wrap.appendChild(makeHeartBtn(''));

    var count = document.createElement('div');
    count.className = 'pip-pheart__count';
    count.textContent = baseCount;
    state.countEl = count;
    wrap.appendChild(count);

    title.appendChild(wrap);
    return true;
  }

  function injectAtc() {
    var box = document.querySelector('.product-form__buttons');
    if (!box) return false;
    if (box.querySelector('.pip-heart-btn')) return true;
    box.appendChild(makeHeartBtn('pip-heart-btn--atc'));
    /* desktop: kortere knoptekst zoals Loavies; ook voor variantwissels (Dawn zet de tekst dan opnieuw) */
    if (window.innerWidth >= 750 && CFG.ATC_SHORT) {
      var longTxt = (window.variantStrings && window.variantStrings.addToCart) || 'Aan mandje toevoegen';
      if (window.variantStrings && window.variantStrings.addToCart) window.variantStrings.addToCart = CFG.ATC_SHORT;
      var span = box.querySelector('.product-form__submit span');
      if (span && (span.textContent.trim() === longTxt || span.textContent.trim() === 'Aan mandje toevoegen')) span.textContent = CFG.ATC_SHORT;
    }
    return true;
  }

  /* ---------- label (Sale / Nieuw / Bestseller) ---------- */

  function injectLabel() {
    if (!data.label) return true;
    var ok = true;
    var slider = document.querySelector('.product__media-wrapper slider-component') || document.querySelector('.product__media-wrapper');
    if (slider) {
      if (!slider.querySelector('.pip-plabel')) {
        if (getComputedStyle(slider).position === 'static') slider.style.position = 'relative';
        var el = document.createElement('div');
        el.className = 'pip-plabel';
        el.textContent = data.label;
        slider.appendChild(el);
      }
    } else { ok = false; }
    var title = document.querySelector('.product__info-container .product__title');
    if (title) {
      if (!document.querySelector('.pip-plabel-desk')) {
        var t = document.createElement('div');
        t.className = 'pip-plabel-desk';
        t.textContent = data.label;
        title.parentNode.insertBefore(t, title);
      }
    } else { ok = false; }
    return ok;
  }

  /* ---------- zoom / fullscreen viewer (mobiel) ---------- */

  function sized(src, w) {
    if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function mediaImages() {
    var out = [];
    document.querySelectorAll('.product__media-list .product__media-item img').forEach(function (img) {
      var src = img.currentSrc || img.src;
      if (src && out.indexOf(src) === -1) out.push(src);
    });
    return out;
  }

  function currentSlideIndex() {
    var dots = document.querySelectorAll('.product-media-dots__dot');
    for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('is-active')) return i;
    return 0;
  }

  /* Label en zoomknopje exact boven de onderrand van de FOTO zetten (de bolletjes eronder
     verschillen per telefoon in hoogte, dus dit wordt gemeten in plaats van gegokt). */
  function positionOverlays() {
    /* Label en zoomknopje worden GEMETEN neergezet: horizontaal ten opzichte van het scherm
       (de fotolijst van Dawn steekt links en rechts uit de wrapper) en verticaal boven de
       onderrand van de foto (de hoogte van de bolletjes eronder verschilt per telefoon). */
    if (window.innerWidth >= 750) return;
    var sc = document.querySelector('.product__media-wrapper slider-component') || document.querySelector('.product__media-wrapper');
    if (!sc) return;
    var ul = sc.querySelector('.product__media-list');
    if (!ul) return;
    var scRect = sc.getBoundingClientRect();
    var ulRect = ul.getBoundingClientRect();
    var cw = document.documentElement.clientWidth;
    var diff = Math.round(scRect.bottom - ulRect.bottom);
    if (diff < 0 || diff > 200) diff = 0;
    var zb = sc.querySelector('.pip-zoombtn');
    var lb = sc.querySelector('.pip-plabel');
    if (zb) {
      zb.style.bottom = (diff + 16) + 'px';
      zb.style.right = Math.round(scRect.right - cw + 12) + 'px';
    }
    if (lb) {
      lb.style.bottom = (diff + 20) + 'px';
      lb.style.left = Math.round(0 - scRect.left) + 'px';
    }
  }
  window.addEventListener('resize', positionOverlays);
  window.addEventListener('load', function () { positionOverlays(); setTimeout(positionOverlays, 800); });

  var viewer = null;

  function markActiveThumb(i) {
    if (!viewer) return;
    var thumbs = viewer.querySelectorAll('.pip-zoom__thumb');
    thumbs.forEach(function (t, j) {
      t.classList.toggle('is-active', j === i);
      if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  }

  function unzoomAll() {
    if (!viewer) return;
    viewer.querySelectorAll('.pip-zoom__slide img').forEach(function (img) {
      img.classList.remove('is-zoomed');
      img.style.transform = '';
      img.style.transformOrigin = '';
    });
  }

  function toggleZoom(img, e) {
    if (img.classList.contains('is-zoomed')) {
      img.classList.remove('is-zoomed');
      img.style.transform = '';
      img.style.transformOrigin = '';
    } else {
      var r = img.getBoundingClientRect();
      var t = (e.changedTouches && e.changedTouches[0]) || e;
      var x = r.width ? ((t.clientX - r.left) / r.width) * 100 : 50;
      var y = r.height ? ((t.clientY - r.top) / r.height) * 100 : 50;
      img.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
      img.style.transform = 'scale(' + CFG.ZOOM_SCALE + ')';
      img.classList.add('is-zoomed');
    }
  }

  function buildViewer() {
    var imgs = mediaImages();
    viewer = document.createElement('div');
    viewer.className = 'pip-zoom';
    /* fase 2, B1-08: viewer als dialoog voor schermlezers */
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Productfoto\'s');
    viewer.innerHTML =
      '<div class="pip-zoom__top"><button type="button" class="pip-zoom__close" aria-label="Sluiten">' + X_SVG + '</button></div>' +
      '<div class="pip-zoom__track"></div>' +
      '<div class="pip-zoom__thumbs"></div>';
    var track = viewer.querySelector('.pip-zoom__track');
    var thumbs = viewer.querySelector('.pip-zoom__thumbs');

    imgs.forEach(function (src, i) {
      var s = document.createElement('div');
      s.className = 'pip-zoom__slide';
      s.innerHTML = '<img src="' + sized(src, 1600) + '" alt="Productfoto ' + (i + 1) + '">';
      track.appendChild(s);

      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'pip-zoom__thumb';
      t.setAttribute('aria-label', 'Toon foto ' + (i + 1) + ' van ' + imgs.length);
      t.innerHTML = '<img src="' + sized(src, 160) + '" alt="">';
      t.addEventListener('click', function () {
        unzoomAll();
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
      thumbs.appendChild(t);
    });

    viewer.querySelector('.pip-zoom__close').addEventListener('click', closeViewer);

    var lastTap = 0;
    track.addEventListener('touchend', function (e) {
      var now = Date.now();
      if (now - lastTap < 300) {
        var img = e.target.closest('img');
        if (img) { toggleZoom(img, e); e.preventDefault(); }
      }
      lastTap = now;
    });
    /* dubbelklik werkt ook (voor als iemand met muis op een klein scherm zit) */
    track.addEventListener('dblclick', function (e) {
      var img = e.target.closest('img');
      if (img) toggleZoom(img, e);
    });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = null;
        if (track.clientWidth) markActiveThumb(Math.round(track.scrollLeft / track.clientWidth));
      }, 120);
    });

    document.body.appendChild(viewer);
  }

  function openViewer(startIdx) {
    var opener = document.activeElement;
    if (!viewer) buildViewer();
    unzoomAll();
    document.documentElement.classList.add('pip-zoom-open');
    viewer.style.display = 'flex';
    var track = viewer.querySelector('.pip-zoom__track');
    track.scrollLeft = (startIdx || 0) * track.clientWidth;
    markActiveThumb(startIdx || 0);
    /* focus naar Sluiten en in de viewer houden (fase 2, B1-08) */
    if (window.pipFocus) window.pipFocus.on(viewer, viewer.querySelector('.pip-zoom__close'), opener);
  }

  function closeViewer() {
    if (!viewer) return;
    viewer.style.display = 'none';
    document.documentElement.classList.remove('pip-zoom-open');
    unzoomAll();
    if (window.pipFocus) window.pipFocus.off(viewer);
  }

  /* Escape sluit de viewer (fase 2, B1-08) */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && viewer && viewer.style.display !== 'none') closeViewer();
  });

  function injectZoomIcon() {
    var slider = document.querySelector('.product__media-wrapper slider-component') || document.querySelector('.product__media-wrapper');
    if (!slider) return false;
    if (slider.querySelector('.pip-zoombtn')) return true;
    if (getComputedStyle(slider).position === 'static') slider.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pip-zoombtn';
    b.setAttribute('aria-label', CFG.ZOOM_TIP);
    b.innerHTML = COPY_SVG + '<span class="pip-zoombtn__txt"></span>';
    b.querySelector('.pip-zoombtn__txt').textContent = CFG.ZOOM_TIP;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      openViewer(currentSlideIndex());
    });
    slider.appendChild(b);
    setTimeout(function () {
      b.classList.add('show-tip');
      setTimeout(function () { b.classList.remove('show-tip'); }, 2600);
    }, 2000);
    return true;
  }

  /* ---------- 'Nog X' onder een maat in de maatkiezer ---------- */

  /* de gekozen waarde per optie (in optie-volgorde), zodat bij producten met
     bijvoorbeeld kleur en maat de voorraad van de juiste combinatie wordt getoond */
  function selectedOptions() {
    var vs = document.querySelector('.product__info-container variant-selects, .product__info-container variant-radios');
    if (!vs) return null;
    var vals = [];
    vs.querySelectorAll('fieldset, select').forEach(function (el) {
      if (el.tagName === 'FIELDSET') {
        var c = el.querySelector('input:checked');
        vals.push(c ? c.value : null);
      } else {
        vals.push(el.value);
      }
    });
    return vals;
  }

  function variantForSize(sizeVal, sel) {
    var vars = data.variants || [];
    for (var i = 0; i < vars.length; i++) {
      var o = vars[i].o || [];
      if (o[data.sizeIdx] !== sizeVal) continue;
      var ok = true;
      for (var j = 0; j < o.length; j++) {
        if (j === data.sizeIdx) continue;
        if (sel && sel[j] != null && o[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return vars[i];
    }
    return null;
  }

  /* Fase 2 (B1-06): het maatveld zoeken op het kopje Maat/Size, niet de eerste knoppenrij (dat kan Kleur zijn) */
  function sizeFieldset() {
    var sets = document.querySelectorAll('.product__info-container variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (!lg) continue;
      var t = '';
      for (var n = 0; n < lg.childNodes.length; n++) {
        if (lg.childNodes[n].nodeType === 3) t += lg.childNodes[n].textContent;
      }
      if (/^\s*(maat|size|maten)\b/i.test(t)) return sets[i];
    }
    return document.querySelector('.product__info-container .product-form__input--pill');
  }

  function decorateSizes() {
    if (data.sizeIdx == null || data.sizeIdx < 0) return true;
    if (!(data.variants || []).length) return true;
    var fs = sizeFieldset();
    if (!fs) return false;
    var sel = selectedOptions();
    fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      var esc = window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id;
      var label = fs.querySelector('label[for="' + esc + '"]');
      if (!label) return;
      var v = variantForSize(inp.value, sel);
      var txt = '';
      if (v && v.a && v.q > 0 && v.q <= CFG.SIZE_LEFT) txt = 'nog ' + v.q;
      var span = label.querySelector('.pip-size-left');
      if (txt) {
        if (!span) {
          span = document.createElement('span');
          span.className = 'pip-size-left';
          label.appendChild(span);
        }
        if (span.textContent !== txt) span.textContent = txt;
      } else if (span) {
        span.remove();
      }
    });
    return true;
  }

  /* na een variantwissel rendert Dawn de maatkiezer opnieuw, dus dan opnieuw decoreren */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
      setTimeout(decorateSizes, 150);
      setTimeout(decorateSizes, 700);
    }
  });

  /* De USP-regels (verzendcountdown en retour) horen direct onder de koopknop,
     boven de productvideo's; in de template staan ze er pas na, dus we verplaatsen ze. */
  function placeUsps() {
    var usps = document.querySelector('.pip-usps');
    if (!usps || usps.getAttribute('data-pip-placed')) return true;
    var anchor = document.getElementById('ss-product-videos');
    var col = usps.closest('.product__info-container');
    if (!anchor || !col) return true;
    var videoBlock = anchor;
    while (videoBlock.parentElement && videoBlock.parentElement !== col) videoBlock = videoBlock.parentElement;
    if (videoBlock.parentElement !== col) return true;
    if (videoBlock.compareDocumentPosition(usps) & Node.DOCUMENT_POSITION_FOLLOWING) {
      var uspsBlock = usps;
      while (uspsBlock.parentElement && uspsBlock.parentElement !== col) uspsBlock = uspsBlock.parentElement;
      col.insertBefore(uspsBlock, videoBlock);
    }
    usps.setAttribute('data-pip-placed', '1');
    return true;
  }

  /* ---------- overige opruim-acties in de infokolom ---------- */

  /* Trustpilot sterren bovenin de infokolom verbergen (alleen als CFG.SHOW_TRUSTPILOT op false staat) */
  function hideTrustpilot() {
    if (CFG.SHOW_TRUSTPILOT) return true;
    var items = document.querySelectorAll('.product__info-container .product-info__block-item');
    if (!items.length) return true;
    items.forEach(function (it) {
      var t = (it.textContent || '').toLowerCase();
      if (t.indexOf('tevreden klanten') > -1 || t.indexOf('trustpilot') > -1) it.classList.add('pip-hide');
    });
    return true;
  }

  /* De Maat tabel link naar rechts, op de hoogte van het Maat kopje */
  function placeSizeChart() {
    var el = document.querySelector('.pify_size_chart_wrapper');
    if (!el) return true; /* niet elk product heeft een maattabel */
    if (el.classList.contains('pip-sizechart')) return true;
    var fs = sizeFieldset();
    if (!fs) return false;
    el.classList.add('pip-sizechart');
    fs.appendChild(el);
    return true;
  }

  /* mobiel: tik op een foto opent onze viewer in plaats van de Dawn modal */
  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 750) return;
    var t = e.target.closest('.product__media-toggle');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    openViewer(currentSlideIndex());
  }, true);

  /* ---------- init ---------- */

  function start() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var a = injectTitle();
      var b = injectAtc();
      var c = injectLabel();
      var d = injectZoomIcon();
      var e = hideTrustpilot();
      var f = placeSizeChart();
      var g = decorateSizes();
      var h = placeUsps();
      positionOverlays();
      if ((a && b && c && d && e && f && g && h) || tries > 80) clearInterval(t);
    }, 300);
    setTimeout(function () {
      if (state.known) return;
      var probes = 0;
      var pt = setInterval(function () {
        probes++;
        if (initialProbe() || probes > 20) clearInterval(pt);
      }, 500);
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();